import axios from 'axios'
import { api } from '@/services/config'
import moment from 'moment'
import store from '@/store'
import { mixin } from '@/mixins/helper'

const level1 = {
  namespaced: true,
  state: () => ({
    isLoading: false,
    activeTab: 'perizinan',
    activeSubTab: 'kbli',

    choosedKbli: [],
    choosedIujp: [],
    choosedSbujk: [],
    choosedIujptl: [],
    choosedInubbm: [],
    choosedSiupal: [],

    vendors: [],
    vendorId: '',
    profile: {},
    information: {},
    dataLegal: [],
    sioData: [],
    k3lData: [],
    kplhData: [],

    kbliVendor: [],
    iujpVendor: [],
    iujptlVendor: [],
    sbujkVendor: [],
    siupalVendor: [],
    inubbmVendor: [],

    query: {
      vendorName: '',
      location: '',
      status: '',
      negara: '',
      prov: '',
      kota: '',
      kec: '',
      kel: '',
      tambang: '',
      sio: '',
      k3l: '',
      kplh: '',
      poStart: '',
      poEnd: '',
      eventStart: '',
      eventEnd: '',
      spmStart: '',
      spmEnd: '',
      sioStart: '',
      sioEnd: '',
      k3lStart: '',
      k3lEnd: '',
      kplhStart: '',
      kplhEnd: '',
      gradeStart: '',
      gradeEnd: '',
      csiStart: '',
      csiEnd: '',
      k3lScore: '',
      kplhScore: '',
      kbliSub: '',
      kbliParent: '',
      iujp: '',
      ijuptl: '',
      sbujk: '',
      inubbm: '',
      siupal: '',
    },

    kbliId: null,
    queryOrder: '&order_by=total_po&order_short=desc',
    page: 1,
    perPage: 50,
    totalItems: 0,
    totalPages: 0,
    nextPageLink: null,
    previousPageLink: null,
  }),
  mutations: {
    setData(state, payload) {
      state[payload.name] = payload.value
    },
    async GET_VENDOR(state, params) {
      state.query =
        params && params.query && params.query !== ''
          ? { ...state.query, ...params.query }
          : { ...state.query }

      let allQuery = ''
      let arrQuery = Object.entries(state.query)
      for (let i in arrQuery) {
        if (arrQuery[i][1] != '') {
          allQuery += arrQuery[i][1]
        }
      }

      const url = `${api}/api/v1/vendor-level-1/public?page=${state.page}&limit=${state.perPage}${allQuery}${state.queryOrder}`
      try {
        state.isLoading = true

        const { data } = await axios({
          method: 'GET',
          url,
        })

        console.log('vendors: ', data.data)
        state.vendors = data.data
        state.page = data.pagination.page
        state.perPage = data.pagination.perPage
        state.totalItems = data.pagination.totalItems
        state.totalPages = data.pagination.totalPages

        state.isLoading = false
      } catch (error) {
        console.log('error level 1: ', error)
        state.vendors = []
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_PROFILE_DATA(state, payload) {
      state.vendorId = payload && payload.id
      console.log('payload: ', payload)
      let url = `${api}/api/v1/d-vendor-profile/public?id=${state.vendorId}${state.query.poStart}${state.query.poEnd}${state.query.eventStart}${state.query.eventEnd}${state.query.spmStart}${state.query.spmEnd}${state.query.sioStart}${state.query.sioEnd}${state.query.k3lStart}${state.query.k3lEnd}${state.query.kplhStart}${state.query.kplhEnd}`

      if (payload && payload.tab) {
        state.activeTab = payload.tab.name
        url = `${api}/api/v1/d-vendor-profile/public?request_id=${payload.tab.request_id}`
      }

      try {
        state.isLoading = true
        const { data } = await axios({
          methods: 'GET',
          url,
        })

        console.log('profile: ', data.data)
        state.vendorId = data.data.id
        state.profile = data.data
        state.aribaId = data.data && data.data.ariba_code

        if (state.vendorId) {
          console.log('vendor id: ', state.vendorId)
          payload.onSuccess()
        }

        state.isLoading = false
        return state.profile
      } catch (error) {
        state.isLoading = false
        state.profile = null
        state.aribaId = null
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_INFO_DATA(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
      let url = `${api}/api/v1/d-vendor-informasi?id=${state.vendorId}`

      if (typeof tab == 'object') {
        state.activeTab = tab.name
        state.activeBottom = tab.name
        url = `${api}/api/v1/d-vendor-informasi?request_id=${tab.request_id}`
      }

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        console.log('information: ', data.data)
        state.information = data.data
        let infoKbli =
          data.data &&
          data.data.kbli &&
          data.data.kbli.sort((a, b) => {
            if (a.kbli_sub_id < b.kbli_sub_id) {
              return -1
            }
            if (a.kbli_sub_id > b.kbli_sub_id) {
              return 1
            }
            return 0
          })
        state.information.kbli = infoKbli

        let storeChoosedKbli = []
        if (data.data) {
          for (let i in data.data.kbli) {
            storeChoosedKbli.push({
              id_kbli_vendor: data.data.kbli[i].id,
              ...data.data.kbli[i].kbli_sub,
            })
          }
          state.choosedKbli = storeChoosedKbli
        }

        state.isLoading = false
      } catch (error) {
        console.log('error', error)
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_PERIZINAN(state, tab) {
      state.activeTab = 'perizinan'
    },
    async GET_LEGAL_DOC(state, tab) {
      console.log('active tab: ', tab)
      state.activeTab = tab
      state.activeBottom = tab
      let url = `${api}/api/v1/d-vendor-legal-document?page=1&limit=50&vendor_id=${state.vendorId}`

      if (typeof tab == 'object') {
        state.activeTab = tab.name
        state.activeBottom = tab.name
        url = `${api}/api/v1/d-vendor-legal-document?page=1&limit=50&request_id=${tab.request_id}`
      }

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.data.length > 0) {
          state.dataLegal = data.data
        } else {
          state.dataLegal = []
        }

        console.log('data legal: ', data.data)
        state.dataLegal = data.data
        state.isLoading = false
      } catch (error) {
        state.dataLegal = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
        console.log('state legal doc on store: ', state.dataLegal)
      }
    },
    async GET_SIO_DATA(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
      state.sioData = null

      const url = `${api}/api/v1/d-vendor-sio?page=1&limit=10&vendor_id=${state.vendorId}&order_by=start_date&order_short=asc`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.sioData = data.data
        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_K3L_DATA(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
      state.k3lData = null

      const url = `${api}/api/v1/d-vendor-k3l?page=1&limit=100&vendor_id=${state.vendorId}&order_by=tanggal_efektif&order_short=asc`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.k3lData = data.data
        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_KPLH_DATA(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
      const url = `${api}/api/v1/d-vendor-kplh?page=1&limit=100&vendor_id=${state.vendorId}&order_by=tanggal_efektif&order_short=asc`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.kplhData = data.data
        state.isLoading = false
      } catch (error) {
        state.kplhData = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_KBLI_DATA(state, tab) {
      state.activeSubTab = tab
      const url = `${api}/api/v1/d-vendor-kbli/vendor/${state.vendorId}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        console.log('kbli vendor: ', data.data)
        state.kbliVendor = data.data
        state.isLoading = false
      } catch (error) {
        state.kbliVendor = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_IJUP_DATA(state, tab) {
      state.activeSubTab = tab
      const url = `${api}/api/v1/d-vendor-iujp/vendor/${state.vendorId}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        console.log('iujp vendor: ', data.data)
        state.iujpVendor = data.data
        state.isLoading = false
      } catch (error) {
        state.iujpVendor = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_IJUPTL_DATA(state, tab) {
      state.activeSubTab = tab
      const url = `${api}/api/v1/d-vendor-iujptl/vendor/${state.vendorId}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        console.log('iujptl vendor: ', data.data)
        state.iujptlVendor = data.data
        state.isLoading = false
      } catch (error) {
        state.iujptlVendor = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_SBUJK_DATA(state, tab) {
      state.activeSubTab = tab
      const url = `${api}/api/v1/d-vendor-sbujk/vendor/${state.vendorId}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        console.log('sbujk vendor: ', data.data)
        state.sbujkVendor = data.data
        state.isLoading = false
      } catch (error) {
        state.sbujkVendor = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_SIUPAL_DATA(state, tab) {
      state.activeSubTab = tab
      const url = `${api}/api/v1/d-vendor-siupal/vendor/${state.vendorId}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        console.log('siupal vendor: ', data.data)
        state.siupalVendor = data.data
        state.isLoading = false
      } catch (error) {
        state.siupalVendor = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_INUBBM_DATA(state, tab) {
      state.activeSubTab = tab
      const url = `${api}/api/v1/d-vendor-inu-bbm/vendor/${state.vendorId}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        console.log('inubbm vendor: ', data.data)
        state.inubbmVendor = data.data
        state.isLoading = false
      } catch (error) {
        state.inubbmVendor = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    RESET_QUERY_VALUE(state) {
      state.query = {
        vendorName: '',
        location: '',
        status: '',
        negara: '',
        prov: '',
        kota: '',
        kec: '',
        kel: '',
        tambang: '',
        sio: '',
        k3l: '',
        kplh: '',
        poStart: '',
        poEnd: '',
        eventStart: '',
        eventEnd: '',
        spmStart: '',
        spmEnd: '',
        sioStart: '',
        sioEnd: '',
        k3lStart: '',
        k3lEnd: '',
        kplhStart: '',
        kplhEnd: '',
        gradeStart: '',
        gradeEnd: '',
        csiStart: '',
        csiEnd: '',
        k3lScore: '',
        kplhScore: '',
        kbliSub: '',
        kbliParent: '',
        iujp: '',
        ijuptl: '',
        sbujk: '',
        inubbm: '',
        siupal: '',
      }
    },
  },
  actions: {
    async setCurrentTab({ state, commit }, tab) {
      let name = null
      let payload = {
        id: state.vendorId,
      }

      if (typeof tab == 'object') {
        name = tab.name
        payload = {
          id: null,
          tab,
        }
      } else {
        name = tab
      }
      switch (name) {
        case 'informasi':
          commit('GET_INFO_DATA', tab)
          break
        case 'perizinan':
          await commit('GET_PERIZINAN', 'perizinan')
          await commit('GET_KBLI_DATA', 'kbli')
          break
        case 'legal':
          console.log('store legal')
          break
        case 'sio':
          console.log('store sio')
          break
        case 'k3l':
          console.log('store perizinan')
          break
        case 'kplh':
          console.log('store perizinan')
          break
        default:
          break
      }
    },
  },
}

export default level1
